'use client';

import React, { useState, useEffect } from 'react';
import s from './TableOfContentsPlain.module.scss';
import classNames from 'classnames';
import Icon from '../Icon';

const TableOfContentsPlain = ({
    headings = [],
    onHeadingClick,
    onHeadingInView,
    activeHeading,
    showIntroduction = true,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const classes = classNames(s.Root, { [s['Root--IsOpen']]: isOpen });

    const handleClick = (e, id, text) => {
        e.preventDefault();
        onHeadingClick?.(text);
        if (id) {
            window.history.pushState(null, '', `#${id}`);
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            let current = 'Introduction';
            headings.forEach(({ id, text }) => {
                const el = document.getElementById(id);
                if (el && el.getBoundingClientRect().top <= 80) {
                    current = text;
                }
            });
            onHeadingInView?.(current);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [headings, onHeadingInView]);

    return (
        <nav className={classes}>
            <div
                className={s.MobileDropdown}
                onClick={() => setIsOpen(!isOpen)}>
                <div className={s.MobileDropdownLabel}>
                    <span>{activeHeading}</span>
                    <Icon name="Toc" className={s.MobileDropdownIcon} />
                </div>
            </div>

            <ul className={s.List}>
                {showIntroduction && (
                    <li
                        key="introduction"
                        className={classNames(s.Item, {
                            [s['Item--IsActive']]:
                                activeHeading === 'Introduction',
                        })}>
                        <a
                            href="#introduction"
                            className={s.Link}
                            onClick={(e) =>
                                handleClick(e, 'introduction', 'Introduction')
                            }>
                            Introduction
                        </a>
                    </li>
                )}
                {headings.map(({ id, text }) => {
                    const isActive = activeHeading === text;
                    return (
                        <li
                            key={id}
                            className={classNames(s.Item, {
                                [s['Item--IsActive']]: isActive,
                            })}>
                            <a
                                href={`#${id}`}
                                className={s.Link}
                                onClick={(e) => handleClick(e, id, text)}>
                                {text}
                            </a>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
};

export default TableOfContentsPlain;
